import Keycloak from 'keycloak-js';
import { SSO_HOST, SSO_REALM, SSO_CLIENT, SM_LOGOFF_URL } from '@awp/config';

const keycloak = new Keycloak({
  url: SSO_HOST,
  realm: SSO_REALM,
  clientId: SSO_CLIENT,
});

export const initializeKeycloak = async () => {
  try {
    keycloak.onTokenExpired = () => {
      keycloak.updateToken(5).catch(function (err) {
        console.error('Failed to refresh the token, or the session has expired', err);
      });
    };

    const initOptions = {
      pkceMethod: 'S256',
      checkLoginIframe: false,
      onLoad: 'check-sso',
    };

    await keycloak.init(initOptions);

    return keycloak;
  } catch (err) {
    console.error('Error initializing Keycloak:', err);
    throw new Error('Keycloak initialization failed');
  }
};

export const logout = () => {
  window.location.href = `${SM_LOGOFF_URL}?retnow=1&returl=${encodeURIComponent(
    `${SSO_HOST}/realms/${SSO_REALM}/protocol/openid-connect/logout?post_logout_redirect_uri=${encodeURIComponent(
      window.location.origin,
    )}` +
      '&id_token_hint=' +
      keycloak.idToken,
  )}`;
};
